import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface ButtonType {
  id: string;
  label: string;
  isVisible: boolean;
}

interface ButtonVisibilityToggleProps {
  buttonTypes: ButtonType[];
  onToggle: (id: string) => void;
}

export const ButtonVisibilityToggle = ({
  buttonTypes,
  onToggle,
}: ButtonVisibilityToggleProps) => {
  const [isListVisible, setIsListVisible] = useState(false);

  return (
    <Card className="fixed top-4 right-4 z-50 bg-background border shadow-lg">
      <Button
        variant="ghost"
        onClick={() => setIsListVisible(!isListVisible)}
        className="px-4 py-2"
      >
        Visibilité des boutons
      </Button>
      
      {isListVisible && (
        <div className="p-4 space-y-2 border-t">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium">Visibilité des boutons</h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsListVisible(false)}
              className="p-1"
            >
              <EyeOff className="h-4 w-4 text-muted-foreground" />
            </Button>
          </div>
          
          <div className="space-y-2">
            {buttonTypes.map((button) => {
              const isVisible = button.isVisible;
              return (
                <div key={button.id} className="flex items-center justify-between gap-3">
                  <span className="text-sm">{button.label}</span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onToggle(button.id)}
                    className={`p-1 ${
                      isVisible ? "text-primary" : "text-muted-foreground"
                    }`}
                  >
                    {isVisible ? (
                      <Eye className="h-4 w-4" />
                    ) : (
                      <EyeOff className="h-4 w-4" />
                    )}
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Card>
  );
};